import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './Core_Investor_Protection_Profile.css';

const Core_Investor_Protection_Profile = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"CORE_INVESTOR_PROTECTION_PROFILE",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	CORE_INVESTOR_PROTECTION_PROFILE:-1
  });


  const [CORE_INVESTOR_PROTECTION_PROFILE, setCORE_INVESTOR_PROTECTION_PROFILE] = React.useState(null);
  const [CORE_INVESTOR_PROTECTION_PROFILE_D, setCORE_INVESTOR_PROTECTION_PROFILE_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Core Investor Protection Profile');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/Core_Investor_Protection_Profile',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewCORE_INVESTOR_PROTECTION_PROFILE(clientInfo,"OpenNew");

		navigate('/Core_Investor_Protection_Profile',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Investor_Protection_Profile_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewCORE_INVESTOR_PROTECTION_PROFILE(clientInfo,"OpenNew");
		}
		navigate('/Core_Investor_Protection_Profile',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Investor_Protection_Profile_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Investor_Protection_Profile_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Investor_Protection_Profile_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
		if(Temp_Data2.status!="New"){
			handleDeleteCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data2);
			navigate('/Core_Investor_Protection_Profile#New',{replace:true});
		} 
		else 
			navigate('/Core_Investor_Protection_Profile',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Investor_Protection_Profile',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Investor_Protection_Profile',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Investor_Protection_Profile',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Investor_Protection_Profile',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!CORE_INVESTOR_PROTECTION_PROFILE) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [CORE_INVESTOR_PROTECTION_PROFILE]) ;


  
  
  var Ids = [];
  for(var Ele in CORE_INVESTOR_PROTECTION_PROFILE){
	  for(var Sec in CORE_INVESTOR_PROTECTION_PROFILE[Ele]){
		if(Sec == "id")
			Ids.push(CORE_INVESTOR_PROTECTION_PROFILE[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(CORE_INVESTOR_PROTECTION_PROFILE[Ele]["status"]);
		else if(Array.isArray(CORE_INVESTOR_PROTECTION_PROFILE[Ele][Sec]))
			  for(var Row in CORE_INVESTOR_PROTECTION_PROFILE[Ele][Sec])  // Convert to CORE_INVESTOR_PROTECTION_PROFILE[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in CORE_INVESTOR_PROTECTION_PROFILE[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["CORE_INVESTOR_PROTECTION_PROFILE"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewCORE_INVESTOR_PROTECTION_PROFILE(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_INVESTOR_PROTECTION_PROFILE`).then((response1) => {
		if(!CORE_INVESTOR_PROTECTION_PROFILE) 
			setCORE_INVESTOR_PROTECTION_PROFILE(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_INVESTOR_PROTECTION_PROFILE_D`).then((response2) => {
			setCORE_INVESTOR_PROTECTION_PROFILE_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddCORE_INVESTOR_PROTECTION_PROFILE_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewCORE_INVESTOR_PROTECTION_PROFILE = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_INVESTOR_PROTECTION_PROFILE/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setCORE_INVESTOR_PROTECTION_PROFILE(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataCORE_INVESTOR_PROTECTION_PROFILE = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_INVESTOR_PROTECTION_PROFILE/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutCORE_INVESTOR_PROTECTION_PROFILE = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_INVESTOR_PROTECTION_PROFILE/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostCORE_INVESTOR_PROTECTION_PROFILE = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_INVESTOR_PROTECTION_PROFILE', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteCORE_INVESTOR_PROTECTION_PROFILE = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_INVESTOR_PROTECTION_PROFILE', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["1"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_0"]=value;
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
	Form_Data_onChange("1","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_0",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["1"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_1"]=value;
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
	Form_Data_onChange("1","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_1",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["1"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_2"]=value;
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
	Form_Data_onChange("1","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_2",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
 }; 
  

const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["1"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_3"]=value;
	Form_Data_onChange("1","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_3",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
  }; 
  


const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["1"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_4"]=value;
	Form_Data_onChange("1","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_4",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
  }; 
  

  
      
const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["2"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_0"]=value ? true : false; // optionally just use boolean
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
	Form_Data_onChange("2","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_0",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["2"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_1"]=value ? true : false; // optionally just use boolean
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
	Form_Data_onChange("2","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_1",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["2"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_2"]=value ? true : false; // optionally just use boolean
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
	Form_Data_onChange("2","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_2",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_3_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["2"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_3"]=value ? true : false; // optionally just use boolean
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
	Form_Data_onChange("2","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_3",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_4_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["2"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_4"]=value ? true : false; // optionally just use boolean
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
	Form_Data_onChange("2","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_4",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["3"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_0"]=value ? true : false; // optionally just use boolean
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
	Form_Data_onChange("3","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_0",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["3"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_1"]=value ? true : false; // optionally just use boolean
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
	Form_Data_onChange("3","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_1",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
 }; 
  


    
const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["4"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_4_0"]=value;
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
	Form_Data_onChange("4","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_4_0",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
 }; 
  

const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["9"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_0",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
  }; 
  

    
const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["9"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_1"]=value;
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
	Form_Data_onChange("9","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_1",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["9"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_2"]=value;
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
	Form_Data_onChange("9","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_2",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["9"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_3"]=value;
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
	Form_Data_onChange("9","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_3",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
	Temp_Data["9"]["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_4"]=value;
	//handleAddCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data,App_Data['CORE_INVESTOR_PROTECTION_PROFILE']);
	Form_Data_onChange("9","PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_4",value,Temp_Data);
 	//handleLastDataCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
    setCORE_INVESTOR_PROTECTION_PROFILE(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!CORE_INVESTOR_PROTECTION_PROFILE) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedCORE_INVESTOR_PROTECTION_PROFILE =JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
  updatedCORE_INVESTOR_PROTECTION_PROFILE[Sec] = [...updatedCORE_INVESTOR_PROTECTION_PROFILE[Sec], newRow];
  setCORE_INVESTOR_PROTECTION_PROFILE(updatedCORE_INVESTOR_PROTECTION_PROFILE);
};

const handleDeleteRow = (sec,index) => {
  const updatedCORE_INVESTOR_PROTECTION_PROFILE = JSON.parse(JSON.stringify(CORE_INVESTOR_PROTECTION_PROFILE));
  updatedCORE_INVESTOR_PROTECTION_PROFILE[sec].splice(index, 1);
  setCORE_INVESTOR_PROTECTION_PROFILE(updatedCORE_INVESTOR_PROTECTION_PROFILE);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Core Investor Protection Profile`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Protection Profile ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Protection Profile ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_0" type="text" className="form-control" placeholder="Protection Profile ID" value={CORE_INVESTOR_PROTECTION_PROFILE["1"][`PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_0`]} 
						onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Protection Profile ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_1" type="text" className="form-control" placeholder="Asset ID" value={CORE_INVESTOR_PROTECTION_PROFILE["1"][`PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_1`]} 
						onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_2" type="text" className="form-control" placeholder="Offering ID" value={CORE_INVESTOR_PROTECTION_PROFILE["1"][`PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_2`]} 
						onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Type Code`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_3"  value={CORE_INVESTOR_PROTECTION_PROFILE["1"][`PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_3`]} onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_3_Change} className="form-control" name="Token Type Code"  >
						  <option value="RENT_INCOME_TOKEN">RENT_INCOME_TOKEN</option>
						  <option value="REVENUE_SHARE_TOKEN">REVENUE_SHARE_TOKEN</option>
						  <option value="SALE_PROFIT_TOKEN">SALE_PROFIT_TOKEN</option>
						  <option value="EQUITY_APPRECIATION_TOKEN">EQUITY_APPRECIATION_TOKEN</option>
						  <option value="PREFERRED_EQUITY_TOKEN">PREFERRED_EQUITY_TOKEN</option>
						  <option value="COMMON_EQUITY_TOKEN">COMMON_EQUITY_TOKEN</option>
						  <option value="DEBT_NOTE_TOKEN">DEBT_NOTE_TOKEN</option>
						  <option value="HYBRID_TOKEN">HYBRID_TOKEN</option>
						  <option value="PRE_AUCTION_POOL_TOKEN">PRE_AUCTION_POOL_TOKEN</option>
						  <option value="POST_AUCTION_TOKENIZATION">POST_AUCTION_TOKENIZATION</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Type Code
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Protection Level`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_4"  value={CORE_INVESTOR_PROTECTION_PROFILE["1"][`PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_4`]} onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_1_4_Change} className="form-control" name="Protection Level"  >
						  <option value="Basic">Basic</option>
						  <option value="Standard">Standard</option>
						  <option value="Enhanced">Enhanced</option>
						  <option value="Construction Enhanced">Construction Enhanced</option>
						  <option value="Auction Enhanced">Auction Enhanced</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Protection Level
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Escrow Required`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Escrow Required`)} <input id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_0_Change} 
					  checked={CORE_INVESTOR_PROTECTION_PROFILE?.["2"]?.["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_0"] === "true" || CORE_INVESTOR_PROTECTION_PROFILE?.["2"]?.["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Independent Inspection Required`)} <input id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_1_Change} 
					  checked={CORE_INVESTOR_PROTECTION_PROFILE?.["2"]?.["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_1"] === "true" || CORE_INVESTOR_PROTECTION_PROFILE?.["2"]?.["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_1"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Performance Bond Required`)} <input id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_2_Change} 
					  checked={CORE_INVESTOR_PROTECTION_PROFILE?.["2"]?.["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_2"] === "true" || CORE_INVESTOR_PROTECTION_PROFILE?.["2"]?.["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_2"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_3" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Payment Bond Required`)} <input id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_3" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_3_Change} 
					  checked={CORE_INVESTOR_PROTECTION_PROFILE?.["2"]?.["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_3"] === "true" || CORE_INVESTOR_PROTECTION_PROFILE?.["2"]?.["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_3"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_4" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Reserve Fund Required`)} <input id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_4" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_4_Change} 
					  checked={CORE_INVESTOR_PROTECTION_PROFILE?.["2"]?.["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_4"] === "true" || CORE_INVESTOR_PROTECTION_PROFILE?.["2"]?.["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_2_4"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Developer Guarantee Required`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Developer Guarantee Required`)} <input id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_0_Change} 
					  checked={CORE_INVESTOR_PROTECTION_PROFILE?.["3"]?.["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_0"] === "true" || CORE_INVESTOR_PROTECTION_PROFILE?.["3"]?.["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Freeze Delist Rights`)} <input id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_1_Change} 
					  checked={CORE_INVESTOR_PROTECTION_PROFILE?.["3"]?.["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_1"] === "true" || CORE_INVESTOR_PROTECTION_PROFILE?.["3"]?.["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_3_1"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Investor Claim Process Link`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Investor Claim Process Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_4_0" type="text" className="form-control" placeholder="Investor Claim Process Link" value={CORE_INVESTOR_PROTECTION_PROFILE["4"][`PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_4_0`]} 
						onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Investor Claim Process Link`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_0"  value={CORE_INVESTOR_PROTECTION_PROFILE["9"][`PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_0`]} onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_1" type="text" className="form-control" placeholder="Created By" value={CORE_INVESTOR_PROTECTION_PROFILE["9"][`PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_1`]} 
						onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_2" type="text" className="form-control" placeholder="Created At" value={CORE_INVESTOR_PROTECTION_PROFILE["9"][`PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_2`]} 
						onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_3" type="text" className="form-control" placeholder="Updated By" value={CORE_INVESTOR_PROTECTION_PROFILE["9"][`PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_3`]} 
						onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_4" type="text" className="form-control" placeholder="Updated At" value={CORE_INVESTOR_PROTECTION_PROFILE["9"][`PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_4`]} 
						onChange={PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_05_ESCROW_INVESTOR_PROTECTION_MARKET_CORE_INVESTOR_PROTECTION_PROFILE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default Core_Investor_Protection_Profile;  